var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 8.66667C12.5002 10.5997 10.9332 12.1667 9.00016 12.1667C7.06717 12.1667 5.50016 10.5997 5.50016 8.66667C5.50016 6.73367 7.06717 5.16667 9.00016 5.16667C10.9332 5.16667 12.5002 6.73367 12.5002 8.66667Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833496 8.66667C0.833496 14.7917 9.00016 21.5 9.00016 21.5C9.00016 21.5 17.1668 14.7917 17.1668 8.66667C17.1668 4.15167 13.5152 0.5 9.00016 0.5C4.48516 0.5 0.833496 4.15167 0.833496 8.66667ZM3.16683 8.66667C3.16683 5.44033 5.77383 2.83333 9.00016 2.83333C12.2265 2.83333 14.8335 5.44033 14.8335 8.66667C14.8335 10.8375 13.2985 13.4846 11.2932 15.8838C10.4835 16.8526 9.66894 17.6969 9.00016 18.347C8.33139 17.6969 7.51688 16.8526 6.70715 15.8838C4.7018 13.4846 3.16683 10.8375 3.16683 8.66667Z",
    fill: "#2E3A59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutline);
export default __webpack_public_path__ + "static/media/location_outline.f1bd6cc1bec071ab8ff0c91fcfc9f978.svg";
export { ForwardRef as ReactComponent };